import React from 'react';
import { useGetAppConsentsQuery } from '../../api/appApiSlice';
import VendorConsent from '../metrics/VendorConsent';

const AppVendorConsent = ( { appId, filter } ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetAppConsentsQuery({ appId, filter })
  return (
    <VendorConsent data={data} loaderProps={{isSuccess, isLoading, retry: refetch}}/>
  )
}

export default AppVendorConsent
